
class CartRemoveButton extends HTMLElement {
  constructor() {
    super();

    this.addEventListener("click", (event) => {
      event.preventDefault();
      const cartItems =
        this.closest("cart-items") || this.closest("cart-drawer-items");

      cartItems.updateQuantity(this.dataset.index, 0);
    });
  }
}

customElements.define("cart-remove-button", CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();

    const debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, ON_CHANGE_DEBOUNCE_TIMER);

    this.addEventListener("change", debouncedOnChange.bind(this));
  }

  cartUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.cartUpdateUnsubscriber = subscribe(
      PUB_SUB_EVENTS.cartUpdate,
      (event) => {
        if (event.source === "cart-items") {
          return;
        }
        this.onCartUpdate(event.openCart);
      }
    );
  }

  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }

  onChange(event) {
    const input = event.srcElement;
    const line = input.dataset.index;
    const quantity = input.value;
    const variantId = event.target.dataset.quantityVariantId;

    this.updateQuantity(line, quantity);
  }

  onCartUpdate(openCart = true) {
    fetch(`${routes.cart_url}?_id=cart-icon-bubble`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, "text/html");

        const sourceQty = html.querySelector("#cart-icon-bubble");
        const targetQty = document.querySelector("#cart-icon-bubble");
        
        if(targetQty && sourceQty){
          targetQty.innerHTML = sourceQty.innerHTML;
        }
      });
    if (this.tagName === "CART-DRAWER-ITEMS") {
      fetch(`${routes.cart_url}?section_id=cart-drawer`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(
            responseText,
            "text/html"
          );
          const selectors = [".cart-drawer_inner"];
          for (const selector of selectors) {
            const targetElement = document.querySelector(selector);
            const sourceElement = html.querySelector(selector);
            if (targetElement && sourceElement) {
              targetElement.replaceWith(sourceElement);
            }
          }
        })
        .then(() => {
          const cartDrawer = document.querySelector("cart-drawer");
          console.log(openCart);
          if (openCart === true) {
          cartDrawer.open();
          }
        })
        .catch((e) => {
          console.error(e);
        });
    } else {
      fetch(`${routes.cart_url}?_id=main-cart`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(
            responseText,
            "text/html"
          );
          
          const sourceQty = html.querySelector("cart-items");
          if(sourceQty){
            this.innerHTML = sourceQty.innerHTML;
          }
        })
        .catch((e) => {
          console.error(e);
        });
    }
  }

  getSectionsToRender() {
    return [
      {
        id: "main-cart",
        section: document.querySelector("[data-main-cart-items]").dataset.id,
        selector: "#main-cart",
      },
      {
        id: "cart-footer",
        section: document.getElementById("cart-footer").dataset.id,
        selector: "#cart-footer",
      },
      {
        id: "cart-icon-bubble",
        section: "cart-icon-bubble",
        selector: ".shopify-section",
      },
    ];
  }

  updateQuantity(line, quantity, name, variantId) {
    this.enableLoading();
  
    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });
  
    console.log("Sending to /cart/change.js:", body);
  
    fetch(`${routes.cart_change_url}`, {
      ...fetchConfig(),
      body,
    })
      .then((response) => {
        const contentType = response.headers.get("content-type") || "";
        return response.text().then((text) => {
          if (!contentType.includes("application/json")) {
            console.error("HTML received instead of JSON. Here's the raw response:");
            console.error(text.slice(0, 500)); // Log first 500 chars of HTML
            throw new Error("Expected JSON but received HTML. Likely an error page or redirect.");
          }
  
          try {
            return JSON.parse(text); // safe parse
          } catch (parseError) {
            console.error("Failed to parse JSON:", parseError);
            console.error("Raw response text:", text);
            throw parseError;
          }
        });
      })
      .then((parsedState) => {
        const quantityElements = document.querySelectorAll(
          `[data-id="Quantity-${line}"]`
        );
  
        if (parsedState.errors) {
          quantityElements.forEach((quantityElement) => {
            quantityElement.value = quantityElement.getAttribute("value");
            this.updateLiveRegions(line, parsedState.errors);
          });
        }
  
        this.getSectionsToRender().forEach((section) => {
          const elementToReplace =
            document
              .getElementById(section.id)
              ?.querySelector(section.selector) ||
            document.getElementById(section.id);
  
          const replacementHTML = this.getSectionInnerHTML(
            parsedState.sections?.[section.section],
            section.selector
          );
  
          if (elementToReplace && replacementHTML) {
            elementToReplace.innerHTML = replacementHTML;
          }
        });
  
        publish(PUB_SUB_EVENTS.cartUpdate, {
          source: "cart-items",
          cartData: parsedState,
          variantId: variantId,
        });
      })
      .catch((error) => {
        console.error("updateQuantity error:", error);
      })
      .finally(() => {
        this.disableLoading();
      });
  }

  updateLiveRegions(line, message) {
    const lineItemErrors = document.querySelectorAll(
      `[data-id="line-item-error-wrapper-${line}"]`
    );

    lineItemErrors.forEach((lineItemError) => {
      if (lineItemError) {
        lineItemError.querySelector("span").textContent = message;

        lineItemError.toggleAttribute("hidden", !message);

        if (message) {
          lineItemError.classList.remove("hidden");
        } else {
          lineItemError.classList.add("hidden");
        }
      }
    });
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector).innerHTML;
  }

  enableLoading() {
    const mainCartItems =
      document.querySelector("[data-main-cart-items]") ||
      document.querySelector("[data-cart-drawer-items]");

    if (mainCartItems) {
      mainCartItems.classList.add("u-pointer-off");
    }
  }

  disableLoading() {
    const mainCartItems =
      document.querySelector("[data-main-cart-items]") ||
      document.querySelector("[data-cart-drawer-items]");

    if (mainCartItems) {
      mainCartItems.classList.remove("u-pointer-off");
    }
  }
}

customElements.define("cart-items", CartItems);

class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener(
      "keyup",
      (evt) => evt.code === "Escape" && this.close()
    );
    this.cartCloseElements = this.querySelectorAll("[data-cart-drawer-close]");

    this.cartCloseElements.forEach((element) => {
      element.addEventListener("click", this.close.bind(this));
    });

    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.getElementById("cart-icon-bubble");
    if (!cartLink) return;

    cartLink.setAttribute("role", "button");
    cartLink.setAttribute("aria-haspopup", "dialog");
    cartLink.addEventListener("click", (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener("keydown", (event) => {
      if (event.code.toUpperCase() === "SPACE") {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);

    setTimeout(() => {
      this.style.display = "flex";
    });

    document.body.style.overflow = "hidden";
  }

  close() {
    this.style.display = "none";
    // removeTrapFocus(this.activeElement);
    document.body.style.overflow = "auto";
  }

  getSectionInnerHTML(html, selector = ".shopify-section") {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: "cart-drawer",
        selector: "#cart-drawer-items",
      },
      {
        id: "cart-icon-bubble",
      },
    ];
  }

  getSectionDOM(html, selector = ".shopify-section") {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define("cart-drawer", CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: "cart-drawer-items",
        section: "cart-drawer",
        selector: ".cart-drawer_inner",
      },
      {
        id: "cart-icon-bubble",
        section: "cart-icon-bubble",
        selector: ".shopify-section",
      },
    ];
  }
}

customElements.define("cart-drawer-items", CartDrawerItems);

class CartCloseButton extends HTMLElement {
  constructor() {
    super();

    this.addEventListener("click", (event) => {
      event.preventDefault();
      const cartDrawer = this.closest("cart-drawer");
      cartDrawer.close();
    });
  }
}

customElements.define("cart-close-button", CartCloseButton);

class EmptyCartButton extends HTMLElement {
  constructor() {
    super();

    this.addEventListener("click", (event) => {
      event.preventDefault();
      const cartDrawerItems =
        this.closest("cart-drawer").querySelector("cart-drawer-items");

      fetch(`${routes.cart_clear_url}`, { ...fetchConfig(), method: "POST" })
        .then((response) => {
          cartDrawerItems.onCartUpdate(); // Refresh the cart drawer items
        })
        .then(() => {
          fetch("/?section=cart-icon-bubble")
            .then((response) => {
              if (!response.ok) throw new Error("Network response was not ok");
              return response.text();
            })
            .then((html) => {
              // Parse the fetched HTML
              const parser = new DOMParser();
              const doc = parser.parseFromString(html, "text/html");
              const newContent = doc.getElementById("cart-icon-bubble");

              // Replace the current section's inner HTML
              if (newContent) {
                const currentBubble =
                  document.getElementById("cart-icon-bubble");
                if (currentBubble) {
                  currentBubble.innerHTML = newContent.innerHTML;
                }
              }
            })
            .catch((error) => {
              console.error(
                "There was a problem with the fetch operation:",
                error
              );
            });
        })
        .catch((error) => {
          console.error("Error clearing the cart:", error);
        });
    });
  }
}

customElements.define("empty-cart-button", EmptyCartButton);